import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  listWrapper: {
    margin: 0,
  },
  list: {
    '&::marker': {
      color: theme.palette.cumin.main,
    },
  },
  unorderedlist: {
    margin: 0,
  },
});
